import { css, SerializedStyles } from "@emotion/react";
import { colorVars } from "../../styles/variables";

type ErrorMessageProps = {
  message: string | null;
  customCss?: SerializedStyles;
};

const s = {
  container: css({
    width: "100%",
    padding: "1.6rem",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: colorVars.error,
    borderRadius: 8,
  }),
  message: css({
    fontWeight: 400,
    fontSize: "1.4rem",
    color: colorVars.error,
  }),
};

const ErrorMessage = ({
  message = "An error occurred",
  customCss = css({}),
}: ErrorMessageProps) => {
  return message ? (
    <div data-cy={"error-message"} css={css([s.container, customCss])}>
      {" "}
      <p css={s.message}>
        <i>{message}</i>
      </p>
    </div>
  ) : (
    <></>
  );
};
export default ErrorMessage;
